import { navigation } from '@ecosystem/newron-design-system';
import React from 'react';

interface HitlistUpsellComponentProps {
  text: string;
}

const HitlistUpsellComponent: React.FC<HitlistUpsellComponentProps> = ({ text }) => {
  return (
    <div data-test-id="hitlist-upsell-warning">
      <span data-test-id="hitlist-upsell-message">{text}</span>
      {
        <navigation.Link
          href="https://helpcenter.gfk.com/gfknewron-product-insights"
          data-test-id="hitlist-navigation-link"
        >
          Find out more
        </navigation.Link>
      }
    </div>
  );
};

export default HitlistUpsellComponent;
